import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import {
  Box,
  Typography,
  Button,
  Stack,
  Paper,
} from "@mui/material";

// import QrCodeScannerIcon from "@mui/icons-material/QrCodeScanner";
// import BadgeIcon from "@mui/icons-material/Badge";
import PersonAddIcon from "@mui/icons-material/PersonAdd";
import UploadFileIcon from "@mui/icons-material/UploadFile";

import AddJudokaDialog from "../components/AddJudokaDialog";
import ScanLicenseDialog from "../components/ScanLicenseDialog";
import LicenseLookupDialog from "../components/LicenseLookupDialog";
import ExcelImportDialog from "../components/ExcelImportDialog";

export default function ManageRegistration() {
  const [judokas, setJudokas] = useState([]);

  const [addOpen, setAddOpen] = useState(false);
  const [scanOpen, setScanOpen] = useState(false);
  const [licenseOpen, setLicenseOpen] = useState(false);
  const [excelOpen, setExcelOpen] = useState(false);
  const navigate = useNavigate();

      const isLocal = window.location.hostname === "localhost";
    const API_URL = isLocal ? "http://localhost:7881/api" // backend local sans /api 
        : "/api"; // backend prod avec /api

  const registrationCode =
    localStorage.getItem(
      "registrationCode"
    );

  // console.log(
  //   "ManageRegistration - code :",
  //   registrationCode
  // );

  const loadRegistration = async () => {

    const response = await fetch(
      `${API_URL}/registration/${registrationCode}`
    );

    if (!response.ok) {
      // localStorage.removeItem("registrationCode");
      navigate("/registration");
      return;
    }

    const data = await response.json();

    setJudokas(data.judokas ?? []);
  };

  useEffect(() => {

    if (!registrationCode) {
      navigate("/registration");
      return;
    }

    loadRegistration();

    //  }, [navigate, registrationCode]);
  }, []);

  const refreshJudokas = async () => {
  await loadRegistration();
};

  return (
    <Box
      sx={{
        maxWidth: 1200,
        mx: "auto",
        px: 3,
        py: 4,
      }}
    >
      <Typography
        variant="h4"
        gutterBottom
        fontWeight="bold"
      >
        Mes inscriptions
      </Typography>

      <Stack
        spacing={2}
        direction={{
          xs: "column",
          md: "row",
        }}
        sx={{ mb: 4 }}
      >

        {/* <Button
          startIcon={<QrCodeScannerIcon />}
          variant="contained"
          color="error"
          onClick={() => setScanOpen(true)}
        >
          Scanner une licence
        </Button>

        <Button
          startIcon={<BadgeIcon />}
          variant="outlined"
          onClick={() =>
            setLicenseOpen(true)
          }
        >
          Entrer une licence
        </Button> */}

        <Button
          startIcon={<PersonAddIcon />}
          variant="outlined"
          onClick={() => setAddOpen(true)}
        >
          Ajouter un judoka
        </Button>

        <Button
          startIcon={<UploadFileIcon />}
          variant="outlined"
          onClick={() => setExcelOpen(true)}
        >
          Import Excel
        </Button>
      </Stack>

      <Typography
        variant="h5"
        gutterBottom
      >
        Judokas inscrits ({judokas.length})
      </Typography>

      {judokas.length === 0 && (
        <Paper sx={{ p: 3 }}>
          <Typography>
            Aucun judoka inscrit pour le moment.
          </Typography>
        </Paper>
      )}

      {/* 
      {judokas.length > 0 && (
        <Stack spacing={2}>
          {judokas.map((judoka: any) => (
            <Paper
              key={judoka.id}
              sx={{
                p: 2,
                borderRadius: 2,
              }}
            >
              <Typography
                variant="h6"
                fontWeight="bold"
              >
                {judoka.lastName} {judoka.firstName}
              </Typography>

              <Typography variant="body2">
                Licence : {judoka.licence}
              </Typography>

              <Typography variant="body2">
                Catégorie : {judoka.category}
              </Typography>

              <Typography variant="body2">
                Club : {judoka.clubName}
              </Typography>

              <Typography variant="body2">
                Nationalité : {judoka.nationality}
              </Typography>
            </Paper>
          ))}
        </Stack>
      )} */}

      {judokas.length > 0 && (
        <Stack spacing={2}>
          {judokas.map((judoka: any) => (
            <Paper
              key={judoka.id}
              sx={{
                p: 2,
                borderLeft: "5px solid #f44336",
              }}
            >
              <Typography
                variant="h6"
                fontWeight="bold"
              >
                {judoka.firstName} {judoka.lastName}
              </Typography>

              <Typography color="text.secondary">
                {judoka.category} • {judoka.clubName}
              </Typography>

              <Typography variant="body2">
                Licence : {judoka.licence}
              </Typography>
            </Paper>
          ))}
        </Stack>
      )}

      <AddJudokaDialog
        open={addOpen}
        onClose={() => setAddOpen(false)}
        onAdded={refreshJudokas}
      />

      <ScanLicenseDialog
        open={scanOpen}
        onClose={() => setScanOpen(false)}
      />

      <LicenseLookupDialog
        open={licenseOpen}
        onClose={() =>
          setLicenseOpen(false)
        }
      />

      <ExcelImportDialog
        open={excelOpen}
        onClose={() => setExcelOpen(false)}
        onImported={refreshJudokas}
      />
    </Box>
  );
}